import { Beruf } from '@/domain/mitarbeiter/features/rotationsplan/entities/Beruf';
import { Rotationsplan } from '@/domain/mitarbeiter/features/rotationsplan/entities/Rotationsplan';
import { Standort } from '@/domain/mitarbeiter/features/rotationsplan/entities/Standort';
import { KalenderArbeitsbereich } from '@/domain/mitarbeiter/features/rotationsplan/features/Kalender/entities/kalenderByArbeitsbereiche/KalenderArbeitsbereich';

export type KalenderView = 'byMitarbeiter' | 'byArbeitsbereiche';

export type Abschnitt = { value: string; name: string };

export type KalenderFilterOptions = {
  berufe: string[];
  abschnitte: Abschnitt[];
  standorte: Standort[];
};

export const STATUS = ['geplant', 'aktiv', 'abgeschlossen'] as const;
export type Status = (typeof STATUS)[number];

export type UebersichtFilterOptions = {
  berufe: string[];
  abschnitte: Abschnitt[];
  status: Status[];
  standorte: Standort[];
};

export interface RotationsplanFeatureProps {
  data: {
    uebersicht: {
      rotationsplaene: Rotationsplan[];
    };
    planung: {
      rotationsplaeneByArbeitsbereiche: KalenderArbeitsbereich[];
      rotationsplaene: Rotationsplan[];
    };
    abschnitte: Abschnitt[];
    berufe: Beruf[];
    standorte: Standort[];
  };
  ui: {
    year: string;
    kalender: {
      view: KalenderView;
      currentStartOfWeek: string;
      currentEndOfWeek: string;
      istSortierungAufsteigend: boolean;
      selectedFilterCount: number;
      filter: KalenderFilterOptions;
    };
    uebersicht: {
      filter: UebersichtFilterOptions;
      istSortierungAufsteigend: boolean;
    };
  };
}

export interface RotationsplanFeatureState extends RotationsplanFeatureProps {
  setKalenderView: (view: KalenderView) => void;
  setKalenderSortierung: (istSortierungAufsteigend: boolean) => void;
  setCurrentStartOfWeek: (currentStartOfWeek: string) => void;
  setCurrentEndOfWeek: (currentEndOfWeek: string) => void;
  setKalenderBerufeFilter: (selectedBerufe: string[]) => void;
  setKalenderGliederungFilter: (selectedAbschnitte: Abschnitt[]) => void;
  setKalenderStandortFilter: (selectedStandorte: Standort[]) => void;
  setUebersichtBerufeFilter: (selectedBerufe: string[]) => void;
  setUebersichtGliederungFilter: (selectedAbschnitte: Abschnitt[]) => void;
  setUebersichtStatusFilter: (selectedStatus: Status[]) => void;
  setUebersichtStandortFilter: (selectedStandorte: Standort[]) => void;
  setUebersichtSortierung: (istSortierungAufsteigend: boolean) => void;
  setYear: (year: string) => void;
}
